import React, {useState} from 'react';
import MySaleCard from './card';
import useGetMyAdverisements from '../../../../services/hookService/getMyAdvertisements/useGetAdverisements';
import DotsLoading from '../../../../components/dotsLoading';
import {BottomSheet} from 'react-spring-bottom-sheet';
import {SpanIcon} from '@mazraeapp/react_icon_kit';
import useDeleteMyAdvertisment from '../../../../services/hookService/my-account/deleteMyAdvertisment/useDeleteMyAdvertisment';
import NotFoundIcon from './../../../../assets/image/sponsor/404.svg';
import {useNavigate} from 'react-router-dom';
import useGetAllNotifications from '../../../../services/hookService/getAllNotification/useGetAllNotifications';
export interface DeleteBotoomSheet {
  isOpen: boolean;
  data: null | IMyAdvertismentData;
}
const Sales = () => {
  const navigate = useNavigate();
  const {data, isLoading, refetch} = useGetMyAdverisements({filter: 'sale'});
  const [deleteItem, setDeleteItem] = useState<DeleteBotoomSheet>({
    isOpen: false,
    data: null,
  });
  const {refetch: refetchAdNotificatons} = useGetAllNotifications();
  const {mutate} = useDeleteMyAdvertisment({
    filter: 'advertisement',
    refetch: () => {
      refetch();
      refetchAdNotificatons();
      setDeleteItem({isOpen: false, data: null});
    },
  });

  const handeDeleteItem = (guid: string) => {
    mutate(guid);
  };

  return (
    <>
      {isLoading ? (
        <div className="my-auto">
          <DotsLoading />
        </div>
      ) : (
        <>
          {!data?.length ? (
            <div className="flex flex-col items-center justify-center px-3 text-sm text-gray-800 flex-1">
              <div className="flex flex-col justify-center items-center gap-6">
                <img src={NotFoundIcon} alt="not found" className="w-14" />
                <span>شما در این دسته آگهی‌ ثبت نکرده‌اید</span>
              </div>
              <button
                className="w-full text-farm-shop-500 border-[1px] border-solid !border-farm-shop-500 rounded bg-white py-3 mt-28"
                onClick={() => navigate('/advertisement-registeration')}
              >
                ثبت آگهی فروش
              </button>
            </div>
          ) : (
            data?.map((item, index) => (
              <MySaleCard
                setDeleteItem={setDeleteItem}
                data={item}
                key={index}
                type="advertisement"
              />
            ))
          )}
        </>
      )}
      <BottomSheet
        onDismiss={() => {
          setDeleteItem({isOpen: false, data: null});
        }}
        open={deleteItem.isOpen}
        blocking={true}
        className="transition ease-in-out delay-250 "
      >
        <div className="w-full flex flex-col gap-2 p-3">
          <div className="flex w-full justify-between">
            <p className="text-md font-Regular">حذف آگهی</p>
            <SpanIcon
              className="icon-nameClose-remove text-xl"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            />
          </div>
          <p className="text-sm font-Regular">
            آیا اطمینان به حذف آگهی{' '}
            <span className="text-md font-DemiBold">
              {deleteItem.data?.title}
            </span>{' '}
            دارید؟
          </p>
          <div className="w-full flex justify-between gap-2 items-center text-md font-Medium">
            <button
              className="w-[70%] bg-red-500 h-[48px] text-white text-md rounded-[8px] font-Medium"
              onClick={() =>
                deleteItem.data?.guid && handeDeleteItem(deleteItem.data?.guid)
              }
            >
              بله، حذف
            </button>
            <button
              className="w-[30%] text-farm-shop-500 h-[48px] text-md font-Medium border border-farm-shop-500 rounded-[8px]"
              onClick={() => setDeleteItem({isOpen: false, data: null})}
            >
              خیر
            </button>
          </div>
        </div>
      </BottomSheet>
    </>
  );
};

export default Sales;
